import { render, staticRenderFns } from "./CollectionPayCertificate.vue?vue&type=template&id=05b3511f&scoped=true"
import script from "./CollectionPayCertificate.vue?vue&type=script&lang=js"
export * from "./CollectionPayCertificate.vue?vue&type=script&lang=js"
import style0 from "./CollectionPayCertificate.vue?vue&type=style&index=0&id=05b3511f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3511f",
  null
  
)

export default component.exports